"use client" 

import UserProfile from "@/components/profile";

export default function TeacherProfile() {
  return <UserProfile role = "teacher" />
}